import(/* webpackMode: "eager" */ "/vercel/path0/Website/node_modules/next/dist/client/link.js")